<template>
  <section class="policy-invoice main">
    <h3>Policy & Invoice</h3>
    <div
      v-if="isManual"
      class="abs-top-right">
      <v-button
        icon="plus"
        plain
        type="primary"
        @click="onAddRecord">Add Record</v-button>
    </div>
    <section v-if="!isManual">
      <div class="main flex-sb">
        <div class="left">
          <div
            v-for="(item, index) in currentPolicyPeriods"
            :key="'key-' + index"
            class="period-item"
            :class="{ 'active': index == 0 }"
          >
            <span class="bold">{{ item.type_language }}</span>
            <span>{{ item.period }}</span>
          </div>
        </div>
        <div class="container flex-1">
          <div
            v-for="(record, rIndex) in invoiceList.record"
            :key="rIndex"
            class="card card-table"
            :class="{ 'table-gray': (record.stts == 0 || (record.stts == 410 && record.type == 10 && hasAdjust)) }"
          >
            <div class="header flex-sb">
              <div>
                <span class="title">{{ record.type_language }}</span>
                <span class="date">{{ record.period_start }}</span>
              </div>
              <div>
                <span
                  class="edit-span hand"
                  @click="handlerEdit(rIndex)">Edit</span>
              </div>
            </div>
            <el-table
              :data="record.data"
              :header-row-class-name="'tableHeader'"
              style="width: 100%">
              <el-table-column label="Document">
                <template #default="scope">
                  <div class="flex-align-center">
                    <span
                      :class="{
                        'text-line':  ((record.stts == 0 || (record.stts == 410 && record.type == 10 && hasAdjust)) && !scope.row.isBrochure)
                      }"
                    >{{ scope.row.document }}</span>
                    <span
                      v-if="scope.row.from==2||scope.row.from==1||scope.row.from==4"
                      :class="{'block-circle__blue':scope.row.from==2}"
                      class="block-circle">{{sys_name(scope.row.from)}}</span>
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="File">
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.file && scope.row.file.url"
                    class="blue pointer"
                    :class="{
                      'text-line':  ((record.stts == 0 || (record.stts == 410 && record.type == 10 && hasAdjust)) && !scope.row.isBrochure)
                    }"
                    @click="openFile(scope.row.file.url)"
                  >{{ scope.row.file.client_name }}</span>
                  <span
                    v-else
                    class="missing">No File</span>
                </template>
              </el-table-column>

              <el-table-column label="Action">
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.file && scope.row.file.url"
                    class="blue pointer"
                    @click="handlerDownloadName(scope.row)"
                  >Download</span>
                  <v-button
                    v-if="scope.row.action"
                    type="text"
                    :stop="true">{{ scope.row.action }}</v-button>
                </template>
              </el-table-column>
              <el-table-column
                label="Date"
                prop="upload_date"
              >
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.file && scope.row.file.upload_date"
                    class="span-time">{{scope.row.file.upload_date}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </section>
    <section v-else>
      <div
        v-for="(item, index) in invoiceList"
        :key="index"
        class="card card-table">
        <div class="header flex-sb">
          <div>
            <span class="title">{{ item.type_language }}</span>
            <span class="date">{{ item.period_start }}</span>
          </div>
          <div>
            <span
              class="edit-span"
              @click="handlerManualEdit(index)">Edit</span>
          </div>
        </div>
        <el-table
          :data="item.record"
          :header-row-class-name="'tableHeader'"
          style="width: 100%">
          <el-table-column
            label="Documents">
            <template #default="{ row }">
              <div class="flex-align-center">
                <span>{{row.document}}</span>
                <span
                  v-if="row.from==2||row.from==1||row.from==1"
                  class="block-circle"
                  :class="{'block-circle__blue':row.from==2}"
                >{{sys_name(row.from)}}</span>
              </div>
            </template>
          </el-table-column>
          <!--          <el-table-column-->
          <!--            prop="from"-->
          <!--            label="From"></el-table-column>-->
          <!--          <el-table-column-->
          <!--            prop="uploaded_by"-->
          <!--            label="Uploaded By"></el-table-column>-->
          <el-table-column label="File">
            <template slot-scope="scope">
              <section>
                <span
                  v-if="scope.row.file && scope.row.file.url"
                  class="blue pointer"
                  @click="openFile(scope.row.file.url)"
                >{{ scope.row.file.client_name }}

                </span>
                <span
                  v-else
                  class="missing">Missing</span>
              </section>
            </template>
          </el-table-column>
          <el-table-column
            label="Action"
            width="130px">
            <template slot-scope="scope">
              <section
                v-if="['Quotation', 'Invoice', 'Receipt'].includes(scope.row.document)"
                class="btn-container"
              >
                <v-upload
                  btnType="text"
                  :uploadData="{
                    order_id: item.id,
                    type: scope.row.type
                  }"
                  :otherData="{
                    recordIndex: scope.$index,
                    index: index
                  }"
                  :direct="0"
                  :label="scope.row.file? 'Replace': 'Upload'"
                  @uploadSuccess="handlerManualUploadSuccess"
                />
                <span
                  v-if="scope.row.file"
                  class="danger pointer pd-l-10"
                  @click="handlerDelete(scope.row.document,scope.$index, scope.row.type, index)"
                >Delete</span>
              </section>
            </template>
          </el-table-column>
          <el-table-column
            label="Date"
            prop="upload_date"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.file && scope.row.file.upload_date"
                class="span-time">{{scope.row.file.upload_date}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </section>

    <!-- <v-dialog
      v-model="manualDialog"
      width="700px">
      <div class="dialog-container">
        <el-table
          :data="recordData.data"
          stripe
          style="width: 100%">
          <el-table-column
            prop="document"
            label="Document"></el-table-column>
          <el-table-column
            prop="from"
            label="From"></el-table-column>
          <el-table-column
            prop="uploaded_by"
            label="Uploaded By"></el-table-column>
          <el-table-column label="File">
            <template slot-scope="scope">
              <section>
                <span
                  v-if="scope.row.file && scope.row.file.url"
                  class="blue pointer"
                  @click="openFile(scope.row.file.url)"
                >{{ scope.row.file.client_name }}</span>
                <span
                  v-else
                  class="missing">Missing</span>
              </section>
            </template>
          </el-table-column>
          <el-table-column label="Action">
            <template slot-scope="scope">
              <v-upload
                btnType="text"
                :uploadData="{
                  order_id: recordData.id,
                  type: scope.row.type
                }"
                :otherData="{
                  index: scope.$index
                }"
                :direct="0"
                :label="(scope.row.file && scope.row.file.url)? 'Replace': 'Upload'"
                @uploadSuccess="handlerUploadSuccess"
              />
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <span
                v-if="scope.row.file && scope.row.file.url"
                class="danger pointer"
                @click="handlerDelete(scope.$index, scope.row.type)"
              >Delete</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="dialog-footer flex-sb">
          <div>
            <v-button @click="dialog = false">Cancel</v-button>
          </div>
          <div>
            <v-button
              type="primary"
              @click="dialog = false">Confirm</v-button>
          </div>
        </div>
      </div>
    </v-dialog> -->

    <v-dialog
      v-model="dialog"
      width="700px">
      <div class="dialog-container">
        <div
          class="dialog-header">
          <div class="flex-sb-center header-title">
            <span>Edit Docs</span>
            <font-awesome-icon
              icon="times"
              class="close"
              @click="onCloseDialog"></font-awesome-icon>
          </div>
        </div>
        <div class="card card-table">
          <div
            class="header flex"
            :class="{'header__none_table':isAdd}">
            <span class="title">{{ isManual?action_type_lang:recordData.type_language }}</span>
            <span
              v-if="!isManual"
              class="date">{{ recordData.period_start }}</span>
            <div v-else>
              <div
                v-if="!isEditNewPolicy"
                class="form-item mg-l-15">
                <v-date-picker v-model="formData.pcy_cmnt_dt" />
              </div>
            </div>
          </div>
          <el-table
            v-if="!isAdd"
            :data="recordData.data || []"
            :header-row-class-name="'tableHeader'"
            style="width: 100%">
            <el-table-column
              label="Document">
              <el-table-column
                label="Documents">
                <template #default="{ row }">
                  <div class="flex-align-center">
                    <span>{{row.document}}</span>
                    <span
                      v-if="[1,2,4].includes(row.from)"
                      class="block-circle"
                      :class="{'block-circle__blue':row.from==2}"
                    >{{sys_name(row.from)}}</span>
                  </div>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="File">
              <template slot-scope="scope">
                <section>
                  <span
                    v-if="scope.row.file && scope.row.file.url"
                    class="blue pointer"
                    @click="openFile(scope.row.file.url)"
                  >{{ scope.row.file.client_name }}</span>
                  <span
                    v-else
                    class="missing">No File</span>
                </section>
              </template>
            </el-table-column>
            <el-table-column
              label="Action"
            >
              <template slot-scope="scope">
                <span class="flex action-list">
                  <v-button
                    v-if="uploadDialogArr.includes(scope.row.type)"
                    type="text"
                    class="mg-r-15"
                    :disabled="scope.row.document == 'Official Policy' && ![425,710,510].includes(stts)"
                    @click="handlerUpload(scope.row, scope.$index)">
                    {{ (scope.row.file && scope.row.file.url)? 'Replace': 'Upload' }}
                  </v-button>
                  <v-upload
                    v-else
                    btnType="text"
                    class="mg-r-15"
                    :uploadData="{
                      order_id: recordData.id,
                      type: scope.row.type
                    }"
                    :otherData="{
                      index: scope.$index
                    }"
                    :direct="0"
                    :label="(scope.row.file && scope.row.file.url)? 'Replace': 'Upload'"
                    @uploadSuccess="handlerUploadSuccess"
                  />
                  <v-button
                    v-if="scope.row.is_rebuild==1"
                    type="text"
                    class="mg-r-15"
                    @click="handleRebuild(scope.row.type)"
                  >Rebuild</v-button>
                  <span
                    v-if="scope.row.file && scope.row.file.url"
                    class="danger pointer"
                    @click="handlerDelete(scope.row.document,scope.$index, scope.row.type)"
                  >Delete</span>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="dialog-footer flex-sb">
          <div>
            <v-button
              gray
              @click="onCloseDialog">Cancel</v-button>
          </div>
          <div v-if="!isEditNewPolicy">
            <v-button
              green
              @click="onConfirm">Confirm</v-button>
          </div>
        </div>
      </div>
    </v-dialog>

    <v-dialog
      v-model="addDialog"
      width="370px">
      <div class="dialog-container">
        <h3>Add Record</h3>
        <div class="btn-list">
          <v-button @click="onRecordType(1)">Endorsement</v-button>
          <v-button @click="onRecordType(2)">Cancellation</v-button>
        </div>
        <div class="dialog-footer">
          <v-button @click="addDialog = false">Cancel</v-button>
        </div>
      </div>
    </v-dialog>

    <upload-cover-note
      ref="upload-cover-note"
      :form="form"
      :orderId="recordData.id"
      :changeUploadData="changeUploadData"
      @success="handlerUploadCoverNoteSuccess" />
    <official-policy
      ref="official-policy"
      :form="form"
      :isManual="isManual"
      :orderId="recordData.id"
      :changeUploadData="changeUploadData"
      @success="handlerUploadOfficialPolicySuccess" />
    <extra-benefits-policy
      ref="extra-policy"
      :form="form"
      :orderId="recordData.id"
      :changeUploadData="changeUploadData"
      @success="handlerUploadExtraPolicySuccess" />

  </section>
</template>
<script>
import {deleteExtraFile, deleteOrderFile, RebuildPDF} from '@/api/order'
import {addManualPolicyInvoice, editManualPolicyInvoice} from '@/api/policy'
import UploadCoverNote from './dialog/upload-cover-note'
import OfficialPolicy from './dialog/official-policy'
import ExtraBenefitsPolicy from './dialog/wind_policy_dialog'
import {downloadFileName} from '@/utils/download'

export default {
  name: 'PolicyInvoice',
  components: {
    UploadCoverNote,
    OfficialPolicy,
    ExtraBenefitsPolicy
  },
  props: {
    invoice: {
      type: [Object, Array],
      default: () => ({}),
    },
    isManual: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: [String, Number],
      default: '',
    },
    form: {
      type: Object,
      default: () => ({})
    },
    stts: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    return {
      action_type: 0,
      action_type_lang:'',
      invoiceList: [],
      changeUploadData:{},
      dialog: false,
      recordData: {},
      invoiceIndex: -1,
      recordIndex: -1,
      hasAdjust: false,
      addDialog: false,
      formData: {
        action: 1, // 1.Endorsement,2.Cancel
        pcy_cmnt_dt: ''
      },
      isAdd: false,
      uploadIndex: -1,
      activeInvoiceId: null
    }
  },
  computed: {
    uploadDialogArr(){
      let arr =  ['extra_aig_pa_path','extra_aig_ex_pro_path','pcy_pdf_path', 'cvr_pdf_path','extra_car_wind_pro_path','extra_drvr_acc_path','extra_car_key_path']
      return arr
    },
    policyPeriods() {
      return this.invoice.policy_periods||[]
    },
    isEditNewPolicy() {
      return !this.isAdd && this.action_type == 10
    },
    currentPolicyPeriods(){
      // let {pcy_id=''} = this.$route.query||{}
      let {pcy_id=''} = this.form||{}
      let arr = []
      if(pcy_id)
        arr = this.policyPeriods.filter(item=>item.id==pcy_id)
      return arr
    },
    sys_name(){
      return form=>{
        let obj= {
          1:'System',
          2:'Api',
          3:'',
          4:'Client'
        }
        return obj[form]
      }
    }
  },
  watch: {
    invoice: {
      deep: true,
      immediate: true,
      handler(val) {
        if (JSON.stringify(val) != '{}') {
          // 過濾一下 ?
          const value = JSON.parse(JSON.stringify(val))
          this.handler().handlerInvoiceList(value)
        }
      },
    },
  },
  methods: {
    handlerDownloadName(item){
      let {file={},document} = item||{}
      let {url,client_name} = file||{}
      const name = document.replace(/\s/g,'')
      const [,suffix] = client_name.split('.')
      if(url)
        downloadFileName(url, `${name}.${suffix}`)
    },
    onAddRecord() {
      this.formData.pcy_cmnt_dt = ''
      this.addDialog = true
    },
    onRecordType(type) {
      this.formData.action = type
      this.action_type_lang = type===1?'Endorsement':'Cancellation'
      this.addDialog = false
      this.isAdd = true
      this.dialog = true
    },
    onCloseDialog() {
      this.dialog = false
      this.isAdd = false
    },
    onConfirm() {
      if(this.isManual) {
        if(this.isAdd) {
          this.network().addManualPolicyInvoice()
        }
        else {
          this.network().editManualPolicyInvoice()
        }
      }
      else {
        this.dialog = false
        this.isAdd = false
      }
    },
    openFile(url) {
      if (url) {
        window.open(url, '_blank')
      }
    },
    handlerManualEdit(index) {
      this.activeInvoiceId = this.invoiceList[index].id
      // this.recordData = this.invoiceList[index]
      this.recordData = {
        id: this.invoiceList[index].id,
        data: this.invoiceList[index].record
      }
      const invoiceItem = this.invoiceList[index]
      const { type, type_language, pcy_cmnt_date } = invoiceItem

      this.action_type = type
      this.action_type_lang = type_language

      this.formData.pcy_cmnt_dt = pcy_cmnt_date

      this.isAdd = false
      this.dialog = true
    },
    handlerEdit(recordIndex) {
      this.recordData = this.invoiceList.record[recordIndex]
      // this.invoiceIndex = index
      this.isAdd = false
      this.recordIndex = recordIndex
      this.dialog = true
      // this.action_type_lang = this.invoiceList[index].type_language
      this.action_type_lang = this.recordData.type_language

    },
    handlerUpload(row, index) {
      this.uploadIndex = index
      const { type } = row
      this.changeUploadData = row
      let extra_arr = ['extra_aig_pa_path','extra_aig_ex_pro_path','extra_car_wind_pro_path','extra_drvr_acc_path','extra_car_key_path']
      if(type == 'pcy_pdf_path') {
        this.$refs['official-policy'].changeDialog()
      }

      if(extra_arr.includes(type)) {
        this.$refs['extra-policy'].changeDialog()
      }
      if(type == 'cvr_pdf_path') {
        this.$refs['upload-cover-note'].changeDialog()
      }
    },
    handlerUploadSuccess({ data, result, otherData }) {
      const { index } = otherData

      const { type } = this.recordData.data[index]

      let resultData = {
        ...this.recordData.data[index],
        file: data,
        from: 'HoldCover',
        uploaded_by: 'HoldCover'
      }

      // if(type === 'other') {
      //   const otherIndex = this.recordData.data[index].index
      //   result = {
      //     ...result,
      //     index: otherIndex
      //   }
      // }
      this.$set(this.recordData.data, index, resultData)
      this.$emit('update')
      if (!this.isManual) {
        // this.invoiceList[this.invoiceIndex].record[this.recordIndex].file = data
        this.$set(
          this.invoiceList.record[this.recordIndex].data,
          index,
          resultData
        )
      }
    },
    handlerManualUploadSuccess({ data, result, otherData }) {
      const { index, recordIndex } = otherData

      let resultData = {
        ...this.invoiceList[index].record[recordIndex],
        file: data,
        from: 'HoldCover',
        uploaded_by: 'HoldCover'
      }
      this.$emit('update')
      this.$set(
        this.invoiceList[index].record,
        recordIndex,
        resultData)

      // const { type } = this.invoiceList[index]
      // this.invoiceList[index].file = data

      // if(type === 'other') {
      //   this.invoiceList[index].file = [data]
      // }
      // else {
      //   this.invoiceList[index].file = data
      // }
    },
    handleRebuild(type){
      let params = {
        type,
        order_id: this.recordData.id,
      }
      this.network().RebuildPDF(params)
    },
    handlerDelete(name,index, type, invoiceIndex) {
      this.$ConfirmBox({
        message: `Are you sure you wana delete ${name}?`
      }).then(()=>{
        if(type == 'extra_car_wind_pro_path'||type=='extra_drvr_acc_path'){
          this.network().deleteExtraFile(index, type, invoiceIndex)
        }
        else this.network().deleteOrderFile(index, type, invoiceIndex)
      })
    },
    handlerUploadCoverNoteSuccess(data) {
      // this.$emit('update')
      const { cvr_pdf } = data
      this.handlerUploadSuccess({
        data: cvr_pdf,
        otherData: {
          index: this.uploadIndex
        }
      })
      this.$emit('update')
    },
    handlerUploadOfficialPolicySuccess(data) {
      const { pcy_pdf } = data
      this.handlerUploadSuccess({
        data: pcy_pdf,
        otherData: {
          index: this.uploadIndex
        }
      })
      this.$emit('update')
    },
    handlerUploadExtraPolicySuccess(data,key) {
      this.handlerUploadSuccess({
        data: data[key],
        otherData: {
          index: this.uploadIndex
        }
      })
      this.$emit('update')
    },
    handler() {
      return {
        getHandlerData: (data = []) => {
          return data.reduce((result, item) => {
            if (item.type === 'other') {
              const { file } = item
              if (file) {
                let {sme_versions,product_id} = this.$route.query
                if(product_id>=80&&sme_versions==3)
                {
                  result.push(item)
                }
                else {
                  for (let i = 0; i < file.length; i++) {
                    result.push({
                      ...item,
                      index: i,
                      file: file[i],
                    })
                  }
                }
              } else {
                result.push({
                  ...item,
                  index: 0,
                  file: null,
                })
              }
            } else if (item.document == 'Brochure') {
              result.push({
                ...item,
                isBrochure: true,
              })
            } else {
              result.push(item)
            }
            return result
          }, [])
        },
        handlerInvoiceList: (invoiceData) => {
          let result = []
          let temp
          if (this.isManual) {
            temp = JSON.parse(JSON.stringify(invoiceData))
            temp.map((item) => {
              item.record = this.handler().getHandlerData(item.record)
              return item
            })
            result = temp
          } else {
            temp = JSON.parse(JSON.stringify(invoiceData))
            // result = temp.reduce((invoiceResult, item) => {
            temp.record.map((recordItem) => {
              recordItem.data = this.handler().getHandlerData(recordItem.data)
              return recordItem
            })
            //   invoiceResult.push(item)
            //   return invoiceResult
            // }, [])
            result = temp
            // 檢查是否存在 adjust
            result.record.some((item) => {
              if (item.type == 50 && item.stts == 410) {
                this.hasAdjust = true
                return true
              }
            })
          }
          this.invoiceList = result
        },
      }
    },

    network() {
      return {
        addManualPolicyInvoice: async () => {
          let order_id = this.invoiceList[0].id
          const { data } = await addManualPolicyInvoice({
            order_id,
            action: this.formData.action,
            pcy_cmnt_dt: this.formData.pcy_cmnt_dt
          })
          this.dialog = false
          this.$emit('update')
        },
        editManualPolicyInvoice: async () => {
          const { data } = await editManualPolicyInvoice({
            order_id: this.activeInvoiceId,
            pcy_cmnt_dt: this.formData.pcy_cmnt_dt,
            file_data: this.recordData.data
          })
          this.dialog = false
          this.$emit('update')
        },
        deleteOrderFile: async (index, type, invoiceIndex = -1) => {
          const { data } = await deleteOrderFile({
            order_id: invoiceIndex !== -1 ?
              this.invoiceList[invoiceIndex].id : this.recordData.id,
            type,
          })
          this.$message({
            type: 'success',
            message: data.message_language,
          })

          let localData = invoiceIndex != -1
            ? this.invoiceList[invoiceIndex].record[index]
            : this.recordData.data[index]
          const params = {
            ...localData,
            file: null,
            from: '',
            uploaded_by: '',
          }
          if (invoiceIndex == -1) {
            this.$set(this.recordData.data, index, params)
          }

          // 更新表格数据
          if (this.isManual) {
            this.$set(this.invoiceList[invoiceIndex].record, index, params)
            // this.invoiceList[index] = params
          } else {
            this.$set(
              this.invoiceList.record[this.recordIndex].data,
              index,
              params
            )
          }
        },
        deleteExtraFile: async (index, type, invoiceIndex = -1) => {
          const { data } = await deleteExtraFile({
            order_id: invoiceIndex !== -1 ?
              this.invoiceList[invoiceIndex].id : this.recordData.id,
            type:type+'_id',
          })
          this.$message({
            type: 'success',
            message: data.message_language,
          })
          let localData = invoiceIndex != -1
            ? this.invoiceList[invoiceIndex].record[index]
            : this.recordData.data[index]
          const params = {
            ...localData,
            file: null,
            from: '',
            uploaded_by: '',
          }
          if (invoiceIndex == -1) {
            this.$set(this.recordData.data, index, params)
          }

          // 更新表格数据
          if (this.isManual) {
            this.$set(this.invoiceList[invoiceIndex].record, index, params)
            // this.invoiceList[index] = params
          } else {
            this.$set(
              this.invoiceList.record[this.recordIndex].data,
              index,
              params
            )
          }
        },
        RebuildPDF: async (params) => {
          const {data} = await RebuildPDF(params)
          const {code} = data
          if(code === 1000){
            this.$message({
              type: 'success',
              message: data.message_language,
            })
          }
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.policy-invoice {
  position: relative;
  .block-circle{
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #586069;
    padding:1px 8px;
    border: 1px solid #E1E4E8;
    border-radius: 100px;
    display: inline-block;
    margin-left: 10px;
    &.margin-left-0{
      margin-left: 0;
    }
    &__blue{
      border-color: #0366D6;
      color: #0366D6;
    }
  }
  .abs-top-right {
    top: 5px;
  }
  .main {
    padding-top: 10px;
    .left {
      margin-right: 15px;
      width: 200px;
      .active {
        background: #d9ecff;
      }
      .period-item {
        padding: 8px;
        color: #409eff;
        font-size: 12px;
        .bold {
          display: block;
          font-weight: 500;
          font-size: 14px;
        }
      }
    }
    // .container {
    // }
  }
  .card {
    // margin-bottom: 20px;
    padding: 15px;
    border-radius: 6px;
    &.card-table{
      padding: 0!important;
      .header{
        background: #F6F8FA;
        border-radius: 6px 6px 0 0;
        border: 1px solid #D1D5DA;
        padding: 15px 13px;
        .edit-span{
          font-family: Inter;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 20px;
          color: #0366D6;
          cursor: pointer;
        }
      }
      .span-time{
        font-family: Inter;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        color: #6A737D;
      }
      .el-table{
        ::v-deep .tableHeader{
          display: none;
        }
        border: 1px solid #D1D5DA;
        border-top: 0;
        //border-bottom: 0;
        //border-bottom: 0;
        border-radius: 0 0 6px 6px;
        ::v-deep td{
          border-bottom: 1px solid #D1D5DA;
          padding: 10px 0!important;
          .cell{
            padding-left: 15px;
          }
        }
        ::v-deep tr{
          &:last-child{
            td{
              border-bottom: 0;
            }
          }
        }
      }
    }

  }
  .manual-header {
    padding-bottom: 15px;
    text-align: right;
  }
  .header {
    //align-items: center;
    padding-top: 0;
    .form-item{
      margin-bottom: 0!important;
    }
    .title {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #24292E;
    }
    .date {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      padding-left: 10px;
      color: #6A737D;
    }
  }
  .missing {
    color: #91939a;
    font-size: 12px;
    font-style: italic;
  }
  .dialog-container {
    padding: 15px;
    .missing {
      color: #91939a;
      font-size: 12px;
      font-style: italic;
    }
    .danger {
      color: #f56c6d;
    }
    .dialog-header {
      color: #616266;
      margin-bottom: 30px;
      .flex-sb-center{
        padding: 15px;
        margin: -14px;
        background: #F6F8FA;
        span{
          font-weight: 600;
          font-size: 14px;
          line-height: 20px;
          color: #1B1F23;
        }
      }
    }
    .btn-list {
      display: flex;
      flex-direction: column;
      align-items: center;
      .el-button {
        display: block;
        margin: 0 auto 10px auto!important;
      }
    }
    .dialog-footer {
      padding-top: 15px;
    }
    .card {
      // margin-bottom: 20px;
      padding: 15px;
      border-radius: 6px;

      &.card-table{
        padding: 0!important;
        .header{
          background: #F6F8FA;
          border-radius: 6px 6px 0 0;
          border: 1px solid #D1D5DA;
          padding: 15px 13px;
          &__none_table{
            border-radius: 6px;
          }
          .form-item{
            margin-bottom: 0!important;
            padding-bottom: 0px!important;
          }
          .edit-span{
            font-family: Inter;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 20px;
            color: #0366D6;
            cursor: pointer;
          }
        }
        .span-time{
          font-family: Inter;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 20px;
          color: #6A737D;
        }
        .el-table{
          ::v-deep .tableHeader{
            display: none;
          }
          border: 1px solid #D1D5DA;
          border-top: 0;
          border-radius: 0 0 6px 6px;
          ::v-deep td{
            border-bottom: 1px solid #D1D5DA;
            border-right:0px!important;
            padding:5px 0!important;
            .cell{
              padding-left: 15px;
            }
          }
          ::v-deep tr{
            &:last-child{
              td{
                border-bottom: 0;
              }
            }
          }
        }
      }
    }
    .block-circle{
      font-weight: 600;
      font-size: 12px;
      line-height: 18px;
      color: #586069;
      padding:1px 8px;
      border: 1px solid #E1E4E8;
      border-radius: 100px;
      display: inline-block;
      margin-left: 10px;
      &.margin-left-0{
        margin-left: 0;
      }
      &__blue{
        border-color: #0366D6;
        color: #0366D6;
      }
    }
    /deep/ .action-list{
    .btn-label{
        font-weight: 400;
        font-size: 14px;
      }
    }
  }
  .danger {
    color: #f56c6d;
    font-weight: 400;
    font-size: 14px;
  }

  .pd-l-10 {
    display: inline-block;
    padding-left: 10px;
  }
  .btn-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

}
</style>
<style lang="scss">
.table-gray {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  background: #eeeeee;
  /deep/ .el-table {
    background: #eeeeee;
    /deep/ tr,
    /deep/ th {
      background: #eeeeee !important;
      &.el-table__row--striped {
        td {
          background: rgba(0, 0, 0, 0.02);
        }
      }
    }
  }
}
</style>
